<template>
  <div class="PersonelPeriodWork">
    <section-period-search-panel @search="search" />

    <box class="mt-2" :title="$t('personelList')">
      <template slot="top-action-view">
        <v-icon
          v-if="list.length > 0 && visiblePrint"
          @click="print"
          color="white"
          >mdi-printer</v-icon
        >
      </template>
      <div v-if="list.length > 0">
        <monthly-functionality-list-web
          :list="list"
          class="hidden-sm-and-down"
          @onClick="onClick"
        />
        <monthly-functionality-list-mob
          :list="list"
          class="hidden-md-and-up"
          @onClick="onClick"
        />
      </div>
      <div v-else>
        <empty-list />
      </div>
    </box>

    <!-- <period-work class="d-none mt-2" :periodWork="periodWork" /> -->
  </div>
</template>

<script>
//import PeriodWork from "../../components/functionality/period/PeriodWork.vue";
import MonthlyFunctionalityListMob from "../../components/personelOperationReport/personelMonthWork/MonthlyFunctionalityListMob.vue";
import MonthlyFunctionalityListWeb from "../../components/personelOperationReport/personelMonthWork/MonthlyFunctionalityListWeb.vue";
import SectionPeriodSearchPanel from "../../components/personelOperationReport/SectionPeriodSearchPanel.vue";
import EosToastType from "../../model/EosToastType";
import EosUtils from "../../utils/EosUtils";
import TextUtils from "../../utils/TextUtils";
export default {
  components: {
    SectionPeriodSearchPanel,
    //PeriodWork,
    MonthlyFunctionalityListWeb,
    MonthlyFunctionalityListMob,
  },
  data() {
    return {
      periodWork: {},
      list: [],
      period: "",
      year: "",
      isAdmin: false,
      visiblePrint: false,
      sectioncode: "",
    };
  },
  mounted() {
    this.isAdmin = EosUtils.isWebKartAdmin();
    this.loadData();
  },
  methods: {
    search(searchParams) {
      if (!searchParams.year || !searchParams.month) {
        return;
      }
      this.period = searchParams.month;
      this.year = searchParams.year;
      this.sectioncode = searchParams.sectioncode;

      this.list = [];

      const params = new URLSearchParams();
      params.append("month", searchParams.month);
      params.append("year", searchParams.year);
      params.append("sectioncode", searchParams.sectioncode);
      params.append("isperiod", true);

      this.$store.dispatch("GetPersonelMonthWork", { params })
        .then((result) => {
          if (result.type === "success") {
            this.list = result.data.Table;
            this.checkVisiblePrint();
          } else {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: result.error,
            });
          }
        })
        .catch((error) => {
            this.$EosToast.show({
              type: EosToastType.error,
              msg: `${error}`,
            });
          });
      },
    onClick(item) {
      if (EosUtils.isWebKartAdmin()) {
        this.$router.push({
          name: "adminPeriodWorkDetails",
          params: {
            period: this.period,
            year: this.year,
            perno: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
          },
        });
      } else {
        this.$router.push({
          name: "PeriodWorkDetails",
          params: {
            period: this.period,
            year: this.year,
            perno: TextUtils.convertToEnglishDigits(item.PERNO.trim()),
          },
        });
      }
    },
    checkVisiblePrint() {
      if (EosUtils.isWebKartAdmin()) {
        this.visiblePrint = true;
      } else {
        var adminPermissionList = this.$store.state.personel.personelDetail.AdminPermission.Table;
        adminPermissionList.every((element) => {
          var adminPermission = element.adminPermission;
          if (adminPermission && adminPermission[50].toString() == "1") {
            this.visiblePrint = true;
            return false;
          }
          return true;
        });
      }
    },
    print() {
      let routeData = this.$router.resolve({
        name: "rpPersonelPeriodWork",
        params: {
          period: this.period,
          year: this.year,
          sectioncode: this.sectioncode,
        },
      });
      let printUrl = routeData.href;
      window.open(printUrl, "_blank");
    },
    loadData() {
      const searchParams = {
        year: "", // Set initial values for search parameters
        month: "",
        sectioncode: "",
      };
      this.search(searchParams);
    },
  },
};
</script>